import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, Inject, Input } from "@angular/core";
import { TransferStatus } from "./../../model/domain/TransferStatus";
import { TransferService } from "./../../services/tickets/Transfer.service";
import { ValidatorService } from "./../../services/validator.service";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-transfer-status",
  templateUrl: "./transfer-status.component.html",
  styleUrls: ["./transfer-status.component.scss"],
})
export class TransferStatusComponent implements AfterViewInit {
  @Input() ticketId: number = null;

  constructor(
    private transferService: TransferService,
    private datePipe: DatePipe,
    public validator: ValidatorService,
    @Inject(MAT_DIALOG_DATA) data?: any
  ) {
    if (data != null) {
      this.ticketId = data.ticketId;
    }
  }

  senderDocument: (string | RegExp)[] = [];
  recipientDocument: (string | RegExp)[] = [];
  transfer: TransferStatus = new TransferStatus();

  ColumnsFile: string[] = ["date", "status", "errorMessage"];

  ngOnInit() {}

  ngAfterViewInit() {
    this.modelInit();
  }

  modelInit() {
    this.transferService.getTransferStatus(this.ticketId).subscribe((res) => {
      this.transfer = res;

      if (this.validator.validateDocument(this.transfer?.senderDocument)) {
        this.senderDocument = this.validator?.documentLegalPersonMask;
      } else if (
        this.validator.validatePhysicalDocument(this.transfer?.senderDocument)
      ) {
        this.senderDocument = this.validator.documentPhysicalPersonMask;
      }

      if (this.validator.validateDocument(this.transfer?.recipientDocument)) {
        this.recipientDocument = this.validator.documentLegalPersonMask;
      } else if (
        this.validator.validatePhysicalDocument(
          this.transfer?.recipientDocument
        )
      ) {
        this.recipientDocument = this.validator.documentPhysicalPersonMask;
      }

      if (this.transfer?.lastStatusDate != null)
        this.transfer.lastStatusDate = this.datePipe.transform(
          this.transfer.lastStatusDate,
          "yyyy-MM-ddTHH:mm",
          "0000"
        ) as any;

      if (this.transfer?.lastStatusDate != null)
        this.transfer.limitDate = this.datePipe.transform(
          this.transfer.limitDate,
          "yyyy-MM-dd"
        ) as any;

      if (this.transfer?.logList?.length > 0) {
        this.transfer.logList.forEach((log) => {
          if (log.date != null)
            log.date = this.datePipe.transform(
              log.date,
              "yyyy-MM-ddTHH:mm",
              "0000"
            ) as any;
        });
      }
    });
  }
}
